import { CsbFileItem, UploadResult } from '@recruiting-solutions/candidate-ui-shared';
import { FormService } from './form.service';

export interface FormServiceUpload {
    name: string;
    addExistingFiles(existingFiles: CsbFileItem[]): Promise<void>;
    upload(overrideMultiple?: boolean): Promise<UploadResult>;
    folder: string;
    files: CsbFileItem[];
    multiple: boolean;
}

export type HTMLFormServiceUpload = HTMLElement & FormServiceUpload;

export class FormUploadService {
    elementsPicklist = ['csb-upload', '[csb-upload]'];

    constructor(private formService: FormService) {}

    loadObject(values: { [key: string]: CsbFileItem[] | CsbFileItem }, ignoreValues?: string[]) {
        let elements = this.formService.querySelectorAll<HTMLFormServiceUpload>(this.elementsPicklist);

        for (let el of elements) {
            if (ignoreValues && ignoreValues.includes(el.name)) continue;

            if (values[el.name]) {
                this.loadSingle(el, values[el.name]);
            }
        }
    }

    protected loadSingle(el: HTMLFormServiceUpload, value: CsbFileItem[] | CsbFileItem) {
        let array = Array.isArray(value) ? value : [value];
        el.addExistingFiles(array);
    }

    async uploadFiles(): Promise<UploadResult[]> {
        let elements = this.formService.querySelectorAll<HTMLFormServiceUpload>(this.elementsPicklist);
        let uploads: Promise<UploadResult>[] = [];

        const groupedElements: { [key: string]: HTMLFormServiceUpload[] } = {};

        elements.forEach(element => {
            if (groupedElements[element.folder]) {
                groupedElements[element.folder].push(element);
            } else {
                groupedElements[element.folder] = [element];
            }
        });

        Object.values(groupedElements).forEach(elements => {
            const isMultiple = !!elements.find(element => element.multiple);

            if (elements.length === 1) {
                uploads.push(elements[0].upload(isMultiple));
                return;
            }

            for (let i = 1; i < elements.length; i++) {
                elements[i].files = [...elements[i - 1].files, ...elements[i].files];
            }

            uploads.push(elements[elements.length - 1].upload(isMultiple));
        });

        return await Promise.all(uploads);
    }
}
